import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import { CodeInput } from 'shared/ui/CodeInput/CodeInput';
import { CodeInputMobile } from 'shared/ui/CodeInputMobile/CodeInputMobile';
import { MpButton } from 'shared/ui/MpButton';
import { MpLink } from 'shared/ui/MpLink';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { CodeEnteredContainerStyled, ConnectOTVBStyled } from './ConnectOTVB.styles';

import './index.css';

interface Props {
	isInstalled: boolean;
	handleInstall?: () => Promise<void>;
}

export const ConnectOTVB: FC<Props> = ({ isInstalled, handleInstall }) => {
	const { t } = useTranslation();
	const [code, setCode] = useState<string[]>(new Array(9).fill(``));
	const [isOpen, setIsOpen] = useState(false);
	const [codeEntered, setCodeEntered] = useState<boolean>(false);

	const open = (): void => {
		setIsOpen(true);
	};

	const close = (): void => {
		setIsOpen(false);
	};

	const sendRequest = (): void => {
		const url = `https://auth.dodois.io/device/codeconfirmation?userCode=${code.join(``)}`;
		setCode(new Array(9).fill(``));

		setCodeEntered(true);
		if (!isInstalled && !!handleInstall) {
			void handleInstall();
		}
		window.open(url, `_blank`);
	};

	const updateCode = (newCode: string): void => {
		if (newCode.length <= 9) {
			setCode(newCode.split(``));
		}
	};

	const handleClose = (): void => {
		setCode(new Array(9).fill(``));
		setCodeEntered(false);
		close();
	};

	return (
		<>
			{isInstalled ? (
				<div style={{ marginBottom: `16px` }}>
					<MpButton block type='primary' size='large' onClick={open} style={{ marginBottom: `8px` }}>
						{t(`Marketplace_Connect_TV`)}
					</MpButton>
					<a href='https://office-tv-board.dodois.io/auth/sign-in-oidc' target='_blank' rel='noreferrer'>
						<MpButton block size='large'>
							{t(`Marketplace_Configure_TV_Board`)}
						</MpButton>
					</a>
				</div>
			) : (
				<MpButton block type='primary' size='large' onClick={open}>
					{t(`Marketplace_Install`)}
				</MpButton>
			)}
			{/* <MpButton onClick={open}>Подключить</MpButton> */}
			<Modal
				className='otvb-modal'
				bodyStyle={{ borderRadius: `16px` }}
				open={isOpen}
				onCancel={handleClose}
				width='fit-content'
				footer={
					!codeEntered
						? [
								<Button
									key='cancel'
									onClick={handleClose}
									size='large'
									style={{
										margin: `10px 0`,
										borderRadius: `8px`,
										marginRight: `8px`,
										fontSize: `14px`,
									}}
								>
									{t(`Marketplace_Cancel`)}
								</Button>,
								<Button
									size='large'
									type='primary'
									disabled={code.length !== 9}
									key='connect'
									style={{ margin: `10px 0`, borderRadius: `8px`, fontSize: `14px` }}
									onClick={sendRequest}
								>
									{t(`Marketplace_Install`)}
								</Button>,
						  ]
						: null
				}
			>
				{!codeEntered ? (
					<ConnectOTVBStyled>
						<h2>{t(`Marketplace_OTVB_Enter_Code`)}</h2>
						<MpParagraph style={{ marginBottom: `28px`, fontSize: `14px` }}>
							{t(`Marketplace_OTVB_Code_Modal_Text_1`)}
							<MpLink url='https://office-tv-board.dodois.io/' text='vdo.do/otvb' />.{` `}
							{t(`Marketplace_OTVB_Code_Modal_Text_2`)}
						</MpParagraph>
						<CodeInput code={code} updateCode={setCode} splitBy={3} onEnter={sendRequest} />
						<CodeInputMobile code={code} updateCode={updateCode} />
					</ConnectOTVBStyled>
				) : (
					<CodeEnteredContainerStyled>
						<InfoCircleOutlined style={{ fontSize: `64px`, height: `64px`, color: `#1677FF` }} />
						<MpText style={{ width: `100%`, lineHeight: `22px` }} size={14}>
							{t(`Marketplace_OTVB_Info_Modal_Text`)}
						</MpText>
						<MpButton
							type='primary'
							size='large'
							block
							onClick={() => setCodeEntered(false)}
							style={{ borderRadius: `8px`, marginTop: `12px`, fontWeight: `400`, fontSize: `14px` }}
						>
							{t(`Marketplace_OTVB_Repeat_Connection`)}
						</MpButton>
						<MpButton
							size='large'
							block
							onClick={handleClose}
							style={{ borderRadius: `8px`, fontWeight: `400`, fontSize: `14px` }}
						>
							{t(`Marketplace_OTVB_All_Connected`)}
						</MpButton>
					</CodeEnteredContainerStyled>
				)}
			</Modal>
		</>
	);
};
